import { render, staticRenderFns } from "./needs-attention-counts.vue?vue&type=template&id=39820863&scoped=true&"
import script from "./needs-attention-counts.vue?vue&type=script&lang=js&"
export * from "./needs-attention-counts.vue?vue&type=script&lang=js&"
import style0 from "./needs-attention-counts.vue?vue&type=style&index=0&id=39820863&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39820863",
  null
  
)

export default component.exports